import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconModule, IconSize } from '@hglobal/fin-ui';

import { DotPulseComponent } from '../dot-pulse/dot-pulse.component';

@Component({
  selector: 'iw-info-dialog-content',
  imports: [IconModule, DotPulseComponent],
  templateUrl: './info-dialog-content.component.html',
  styleUrl: './info-dialog-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoDialogContentComponent {
  readonly title = input<string>();
  readonly iconName = input<string>();
  readonly iconSize = input<IconSize>('40');
  readonly status = input<'failed' | 'succeeded' | 'pending'>();
}
